import axios from '../http'
import {API} from "../const"

const api = API+'/ql/bank';

const error = (name) => (e) => console.error(name + ':=>', e);



export function bankCardList(cb, fcb = error('bankCardList')) {
  axios.get(api+'/card-info').then(response => {
    cb(response.data);
  }).catch(err => {
    fcb(err);
  })
}


export function addBank(params, cb, fcb = error('addBank')) {
  axios.post(api + '/bank', params).then(response => {
    cb(response.data);
  }).catch(err => {
    fcb(err);
  })
}



export function deleteBankCard(params, cb, fcb = error('deleteBankCard')) {
  axios.delete(api+'/bank?bankCard='+params).then(response => {
    cb(response.data);
  }).catch(err => {
    fcb(err);
  })
}


export var banks = ['浦东发展银行','德州银行','华夏银行','交通银行','平安银行','青岛银行','日照银行','日照市商业银行','泰安市商业银行','兴业银行','招商银行','工商银行','光大银行','建设银行','民生银行','农业银行','邮政储蓄银行','邮储银行','中信银行','中国银行','齐鲁银行'];
export var img = {
    getUrl: function(bankName){
        let bank = this.isImg(bankName);
        switch (bank) {
            case '浦东发展银行':
                return '浦发银行';
            case '德州银行':
                return '德州银行';
            case '华夏银行':
                return '华夏银行';
            case '交通银行':
                return '交通银行';
            case '平安银行':
                return '平安银行';
            case '青岛银行':
                return '青岛银行';
            case '日照银行':
                return '日照银行';
            case '日照市商业银行':
                return '日照银行';
            case '泰安市商业银行':
                return '泰安银行';
            case '兴业银行':
                return '兴业银行';
            case '招商银行':
                return '招商银行';
            case '工商银行':
                return '中国工商银行';
            case '光大银行':
                return '中国光大银行';
            case '建设银行':
                return '中国建设银行';
            case '民生银行':
                return '中国民生银行';
            case '农业银行':
                return '中国农业银行';
            case '中国银行':
                return '中国银行';
            case '邮政储蓄银行':
                return '中国邮政储蓄银行';
            case '邮储银行':
                return '中国邮政储蓄银行';
            case '齐鲁银行':
                return '齐鲁银行';
            default:
                return '中信银行';
        }
    },
    isImg:function(bankName){
        let bank;
        if(bankName == ''){
            return bank;
        }
        for(let i = 0;i<= banks.length;i++){
            if(bankName.indexOf(banks[i])!=-1){
                bank = banks[i];
                break
            }
        }
        return bank;
    }
}